
export const RECIPES = 'recipes';
export const RECIPE_FEEDBACKS = 'recipe-feedbacks';
export const MEAL_PLANS = 'meal-plans';
export const MEAL_NOTES = 'meal-notes';
export const FAMILY = 'family';
export const INGREDIENT_PREFERENCES = 'ingredient-preferences';
export const RECIPE_SEARCHES = 'recipe-searches';
export const MEAL_COMPOSITIONS = 'meal-compositions';

// Additional query keys for hooks
export const USER_PROFILE = 'user-profile';
export const FAMILY_MEMBERS = 'family-members';
export const FAMILY_INVITE_CODE = 'family-invite-code';
export const FAMILY_ADMIN = 'family-admin';
export const IS_FAMILY_ADMIN = 'is-family-admin';
export const CURRENT_USER_FAMILY = 'current-user-family';
export const CONSOLIDATED_PROFILE = 'consolidated-profile';
export const HOMEPAGE_MEAL_PLANS = 'homepage-meal-plans';

// Helper functions for generating entity-specific keys
export const getEntityKey = (baseKey: string, entityId: string | null | undefined) => {
  return [baseKey, entityId];
};

export const getDateBasedKey = (baseKey: string, startDate: string, endDate: string, userId?: string, familyId?: string | null) => {
  return [baseKey, startDate, endDate, userId, familyId];
};

// Standardized meal plan query key generators
export const getMealPlansQueryKey = (startDate: string, endDate: string, familyId?: string | null) => {
  return [MEAL_PLANS, startDate, endDate, familyId];
};

// Query key patterns for invalidation
export const MEAL_PLAN_PATTERNS = {
  all: [MEAL_PLANS],
  byFamily: (familyId: string | null) => [MEAL_PLANS, { familyId }],
  byDateRange: (startDate?: string, endDate?: string) => [MEAL_PLANS, { startDate, endDate }]
};
